import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter } from './BoxesUIHelpers';

const BoxesUIContext = createContext();

export function useBoxesUIContext() {
  return useContext(BoxesUIContext);
}

export const BoxUIConsumer = BoxesUIContext.Consumer;

export function BoxesUIProvider({ BoxesUIEvents, children }) {
  const [boxForView, setBoxForViewBase] = useState();
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  const setQueryParams = useCallback(
    (nextQueryParams) => {
      setQueryParamsBase((prevQueryParams) => {
        if (isFunction(nextQueryParams)) {
          nextQueryParams = nextQueryParams(prevQueryParams);
        }
        if (isEqual(prevQueryParams, nextQueryParams)) {
          return prevQueryParams;
        }
        return nextQueryParams;
      });
      console.log('BoxesUIProvider.setQueryParams', queryParams);
    },
    [queryParams]
  );

  const setBoxForView = useCallback((nextBoxForView) => {
    setBoxForViewBase((prevBoxForView) => {
      if (isFunction(nextBoxForView)) {
        nextBoxForView = nextBoxForView(prevBoxForView);
      }
      if (isEqual(prevBoxForView, nextBoxForView)) {
        return prevBoxForView;
      }
      return nextBoxForView;
    });
  }, []);

  const value = {
    queryParams,
    boxForView,
    setQueryParams,
    setBoxForView,
    openViewBoxDialog: BoxesUIEvents.openViewBoxDialog,
  };

  return (
    <BoxesUIContext.Provider value={value}>{children}</BoxesUIContext.Provider>
  );
}
